export default "__VITE_ASSET__D4pRF8JT__"